import { isEmpty } from "lodash";
import { LABSTORE_ACCESS, ROLES } from "./constants";

const isAuthorized = (authRoles, currentRoles) => {
    return currentRoles?.some((role) => authRoles?.includes(role));
};

const isLabstoreAuthorized = (currentUser, action) => {
    const storeAccess = currentUser?.organization?.storeAccess;

    if (isEmpty(storeAccess) && currentUser?.role !== ROLES.superAdmin)
        return false;
    else if (!action) return true;

    switch (action) {
        case LABSTORE_ACCESS.view:
            return storeAccess?.view;
        case LABSTORE_ACCESS.subscribe:
            return storeAccess?.subscribe;
        case LABSTORE_ACCESS.publish:
            return storeAccess?.publish;
        default:
            return false;
    }
};

export { isAuthorized, isLabstoreAuthorized };
